export const game: GameSetup = {
    ball: {
        drop: -10,
        size: 15,
        speed: 0.4,
        spread: 0.05,
        start: -15,
    },
    board: {
        dropShadow: 10,
        height: 420,
        offset: {
            x: 45,
            y: 145,
        },
        padding: 20,
        spacing: {
            x: 510 / (10 + 2),
            y: (420 - 20) / (10 + 1),
        },
        width: 510,
    },
    bucket: {
        values: [0, 0, 0, 0, 0, 50, 100, 250, 500, 1000, 2000],
    },
    container: {
        height: 700,
        width: 510 + 45 * 2,
    },
    cost: {
        spinner: {
            max: 9,
            min: -9,
        },
        values: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
    },
    gate: {
        height: 5,
        hitarea: 8,
        width: 18,
    },
    history: {
        expiration: 1000 * 60 * 60 * 24,
    },
    pin: {
        size: 15,
    },
    rows: 10,
};
